module.exports = __webpack_public_path__ + "img/www.cfa039f4.svg";